import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'

import { useStyles } from './voucher-form.styles'
import Button from '../../../components/button'

/**
 * Reusable voucher form component
 * Displays voucher input with Redeem and Skip buttons for the change subscription flow and add subscription flow
 */
const VoucherForm = ({
  voucherValue,
  onVoucherChange,
  onRedeem,
  onSkip,
  error,
  isSubmitting
}) => {
  const styles = useStyles()

  return (
    <div className={styles.voucherContainer}>
      <div className={styles.title}>
        Do you have a voucher code?
        <br />
        Enter it here.
      </div>
      <div className={styles.inputContainer}>
        <label className={styles.label}>
          <input
            value={voucherValue}
            name="voucherCode"
            type="text"
            disabled={isSubmitting}
            onChange={event => onVoucherChange(event.target.value)}
            className={classNames(styles.input, {
              [styles.inputError]: Boolean(error)
            })}
          />
        </label>

        <p
          className={classNames(styles.fieldError, {
            [styles.visible]: Boolean(error)
          })}
        >
          {error}
        </p>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          disabled={isSubmitting}
          onClick={onRedeem}
          className={styles.button}
          text="Redeem"
        />
        <Button
          onClick={onSkip}
          disabled={isSubmitting}
          className={styles.button}
          text="Skip"
          darkBGSecondary
        />
      </div>
    </div>
  )
}

VoucherForm.propTypes = {
  voucherValue: PropTypes.string.isRequired,
  onVoucherChange: PropTypes.func.isRequired,
  onRedeem: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  error: PropTypes.string,
  isSubmitting: PropTypes.bool
}

VoucherForm.defaultProps = {
  error: '',
  isSubmitting: false
}

export default VoucherForm
